import { Inject, InjectionToken, Injector, ModuleWithProviders, NgModule, Type } from '@angular/core';
import { EFFECT } from '@shared/util/createEffect';
import { isObservable } from 'rxjs';

const EFFECT_PROVIDERS = new InjectionToken('EFFECT_PROVIDERS');

const isEffect = (effect: any) => {
  return effect[EFFECT];
};

@NgModule({})
export class EffectsModule {
  public constructor(@Inject(EFFECT_PROVIDERS) public providers: Type<any>[], public readonly injector: Injector) {
    for (const provider of providers) {
      const currentProvider: { [propName: string]: () => any } = injector.get(provider);

      for (const effectFactory of Object.values(currentProvider)) {
        if (isEffect(effectFactory)) {
          const factory = effectFactory();

          if (isObservable(factory)) {
            factory.subscribe();
          }
        }
      }
    }
  }

  public static register(providers: Type<any>[]): ModuleWithProviders<EffectsModule> {
    return {
      ngModule: EffectsModule,
      providers: [
        {
          provide: EFFECT_PROVIDERS,
          useValue: providers
        }
      ]
    } as ModuleWithProviders<EffectsModule>;
  }
}
